import {
    Component,
    ChangeDetectionStrategy,
    Inject,
    OnInit,
} from "@angular/core";

import { MediaQueryOption } from "@hermes/aphrodite/media-picture";
import {
    ProductStoryDeprecated,
    PushMerchandisingDeprecated,
} from "@hermes/api-model-editorial";

import { SHOULD_PRELOAD_MEDIA, CHAPTERS_PARAGRAPH } from "../../core";

import { PushMerchAnalyticsService } from "./push-merch-analytics.service";

@Component({
    selector: "h-push-merch",
    templateUrl: "./push-merch.component.html",
    styleUrls: ["./push-merch.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PushMerchComponent implements OnInit {
    public mediaOptions = pushMerchPosterOptions;
    public numberOfProducts!: number;
    constructor(
        @Inject(CHAPTERS_PARAGRAPH)
        public pushMerch: PushMerchandisingDeprecated,
        @Inject(SHOULD_PRELOAD_MEDIA) public shouldPreloadMedia: boolean,
        public pushMerchAnalyticsService: PushMerchAnalyticsService,
    ) {}

    public ngOnInit() {
        this.numberOfProducts = this.pushMerch.merchandisingProducts.length;
    }

    public sendProductClickEvent(
        product: ProductStoryDeprecated,
        productPosition: number,
    ): void {
        this.pushMerchAnalyticsService.sendProductClick(
            product,
            productPosition,
            this.pushMerch.merchandisingPositionInStory,
        );
    }

    public sendImpression(): void {
        this.pushMerchAnalyticsService.sendImpression(
            this.pushMerch.merchandisingProducts,
            this.pushMerch.merchandisingPositionInStory,
        );
    }
}

const pushMerchPosterOptions: MediaQueryOption[] = [
    {
        size: "xsmall",
        mediaQuery: "(min-width: 320px) and (max-width: 414px)",
        width: 308,
    },
    {
        size: "small",
        mediaQuery: "(min-width: 415px) and (max-width: 768px)",
        width: 572,
    },
    {
        size: "medium",
        mediaQuery: "(min-width: 769px) and (max-width: 1024px)",
        width: 762,
    },
    {
        size: "large",
        mediaQuery: "(min-width: 1025px) and (max-width: 1280px)",
        width: 464,
    },
    {
        size: "xlarge",
        mediaQuery: "(min-width: 1281px) and (max-width: 1920px)",
        width: 696,
    },
    { size: "xxlarge", mediaQuery: "(min-width: 1921px)", width: 696 },
];
